export default __webpack_public_path__ + "static/coming-soon-trading-league-7830c48b888db737dfb9e0b57a3613ab.png";